export const DEFAULT_VAULT_ID = 'primary' as const;
export const DEFAULT_VAULT_VERSION = 1 as const;

export type VaultVersion = typeof DEFAULT_VAULT_VERSION;

export interface WalletVaultPayload {
  version: VaultVersion;
  address: string;
  publicKey: string;
  privateKey: string;
  mnemonic: string;
  path: string;
  locale?: string;
}

export interface WalletVaultKdfParams {
  name: 'argon2id';
  opsLimit: number;
  memLimit: number;
  algorithm: number;
  hashLength: number;
  salt: string;
}

export interface WalletVaultCipherParams {
  name: 'XCHACHA20-POLY1305';
  nonce: string;
  ciphertext: string;
}

export interface WalletVaultBlob {
  version: VaultVersion;
  kdf: WalletVaultKdfParams;
  cipher: WalletVaultCipherParams;
}

export interface WalletVaultRecord {
  id: string;
  address: string;
  createdAt: string;
  updatedAt: string;
  vault: WalletVaultBlob;
}

export interface WalletCreationResult {
  address: string;
  mnemonic: string;
  createdAt: string;
  vault: WalletVaultBlob;
  synced: boolean;
}

export interface PasswordStrengthResult {
  ok: boolean;
  issues: string[];
}

export interface WalletVaultSyncRequest {
  userId: string;
  address: string;
  vaultBlob: string;
}

export interface WalletVaultSyncResponse {
  vaultBlob: string;
  address: string;
}

// --- Blockchain Service Types ---

export interface BlockchainBalance {
  address: string;
  balanceWei: string;
  balanceFormatted: string;
  symbol: string;
  decimals: number;
}

export interface TokenBalance {
  address: string;
  tokenAddress: string;
  balanceRaw: string;
  balanceFormatted: string;
  name: string;
  symbol: string;
  decimals: number;
}

export interface ContractCallResult<T = unknown> {
  success: boolean;
  data?: T;
  error?: string;
  contractAddress: string;
  methodName: string;
}

export interface TransactionRequest {
  contractAddress: string;
  abi: string[] | object[];
  methodName: string;
  args?: unknown[];
}

export interface TransactionResult {
  success: boolean;
  transactionHash?: string;
  blockNumber?: number;
  gasUsed?: string;
  error?: string;
}

export interface PaymentItem {
  recipient: string;
  amount: bigint;
}
